import { defineMessage } from 'services/localization';

export const messages = {
    popupTitle: defineMessage('edit_groupname'),
    save: defineMessage('save'),
    fieldType: defineMessage('field_type_2'),
    clear: defineMessage('clear'),
    successMessage: defineMessage('groupname_has_been_updated'),
    account: defineMessage('account'),
    edit: defineMessage('edit'),
    noChanges: defineMessage('there_were_no_changes_in_the_group_groupname'),
};
